export type AuthStatusTone = "success" | "danger" | "neutral" | "info";

export interface AuthTrackingStat {
  id: string;
  title: string;
  value: string;
  icon: string;
}

export interface AuthAuditEvent {
  id: string;
  title: string;
  status: string;
  statusTone: AuthStatusTone;
  description: string;
}

export interface AuthTrackingRecord {
  id: string;
  claimId: string;
  service: string;
  memberPlan: string;
  payer: string;
  submission: string;
  submissionTone: AuthStatusTone;
  authStatus: string;
  authStatusTone: AuthStatusTone;
  delivery: string;
  deliveryTone: AuthStatusTone;
  http: number;
  attempts: number;
  submittedDate: string;
  submittedTime: string;
  ehrOrganization: string;
  endpoint: string;
  subscription: string;
  decisionDate: string;
  decisionTime: string;
  requestStatus: string;
  requestStatusTone: AuthStatusTone;
  auditTrail: AuthAuditEvent[];
}

export const AUTH_TRACKING_STATS: AuthTrackingStat[] = [
  {
    id: "requests",
    title: "Prior Auth Request",
    value: "2",
    icon: "fh_select_mem_2",
  },
  {
    id: "approved",
    title: "Approved",
    value: "1",
    icon: "fh_check_circle_fill",
  },
  {
    id: "denied",
    title: "Denied",
    value: "1",
    icon: "fh_rejection",
  },
  {
    id: "notify",
    title: "Notify",
    value: "2/0",
    icon: "fh_bell_fill",
  },
];

export const AUTH_TRACKING_ROWS: AuthTrackingRecord[] = [
  {
    id: "1",
    claimId: "claim-0a5399e6-302e-44ac-88a7-90c0340365cb",
    service: "MRI brain w/o contrast",
    memberPlan: "Member - Commercial HMO",
    payer: "Carelon",
    submission: "Completed",
    submissionTone: "success",
    authStatus: "Approved",
    authStatusTone: "success",
    delivery: "Success",
    deliveryTone: "success",
    http: 200,
    attempts: 1,
    submittedDate: "08/10/2026",
    submittedTime: "14:12",
    ehrOrganization: "AaNeelConnectFhirAdmin",
    endpoint: "EHR notification listener",
    subscription: "1825d37sfd746435373e4k8ec",
    decisionDate: "08/10/2026",
    decisionTime: "14:13",
    requestStatus: "Complete",
    requestStatusTone: "success",
    auditTrail: [
      {
        id: "sub-ready",
        title: "Provider subscription ready",
        status: "Success",
        statusTone: "success",
        description: "EHR Registered for prior auth-status updates",
      },
      {
        id: "submitted",
        title: "Provider auth submitted",
        status: "Success",
        statusTone: "success",
        description: "Ordering provider sent request from the EHR",
      },
      {
        id: "routed",
        title: "Routed to health plan",
        status: "Success",
        statusTone: "success",
        description: "Carelon received the authorization request",
      },
      {
        id: "decision",
        title: "Coverage decision recorded",
        status: "Success",
        statusTone: "success",
        description: "prior authorization Approved for request service",
      },
      {
        id: "notify",
        title: "Notification delivery",
        status: "Success",
        statusTone: "success",
        description:
          "Delivery status Success · rest-hook reached the EHR · 1 attempt",
      },
    ],
  },
  {
    id: "2",
    claimId: "claim-1b82c4d9-9e11-62a7-b3f1-81d0451476dc",
    service: "CT abdomen w/ contrast",
    memberPlan: "Member - Medicare Advantage",
    payer: "HealthAxis",
    submission: "Completed",
    submissionTone: "success",
    authStatus: "Denied",
    authStatusTone: "danger",
    delivery: "Success",
    deliveryTone: "success",
    http: 200,
    attempts: 1,
    submittedDate: "08/10/2026",
    submittedTime: "13:48",
    ehrOrganization: "AaNeelConnectFhirAdmin",
    endpoint: "EHR notification listener",
    subscription: "2916e48tge857546484f5l9fd",
    decisionDate: "08/10/2026",
    decisionTime: "13:51",
    requestStatus: "Complete",
    requestStatusTone: "success",
    auditTrail: [
      {
        id: "sub-ready",
        title: "Provider subscription ready",
        status: "Success",
        statusTone: "success",
        description: "EHR Registered for prior auth-status updates",
      },
      {
        id: "submitted",
        title: "Provider auth submitted",
        status: "Success",
        statusTone: "success",
        description: "Ordering provider sent request from the EHR",
      },
      {
        id: "routed",
        title: "Routed to health plan",
        status: "Success",
        statusTone: "success",
        description: "HealthAxis received the authorization request",
      },
      {
        id: "decision",
        title: "Coverage decision recorded",
        status: "Success",
        statusTone: "success",
        description: "prior authorization Denied for request service",
      },
      {
        id: "notify",
        title: "Notification delivery",
        status: "Success",
        statusTone: "success",
        description:
          "Delivery status Success · rest-hook reached the EHR · 1 attempt",
      },
    ],
  },
];
